import { render, staticRenderFns } from "./LockedBalanceView.vue?vue&type=template&id=78cae518&scoped=true&"
import script from "./LockedBalanceView.vue?vue&type=script&lang=js&"
export * from "./LockedBalanceView.vue?vue&type=script&lang=js&"
import style0 from "./LockedBalanceView.vue?vue&type=style&index=0&id=78cae518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78cae518",
  null
  
)

export default component.exports